import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

export const EmptyState = () => {
  return (
    <>
      <Icon.Large icon="document-folder-drawer-2" color="grey600" />
      <Box flexDirection="column" gap="s4" alignItems="center">
        <Text.Normal color="grey800">{i18n.t('tasks.table.empty')}</Text.Normal>
      </Box>
    </>
  )
}
